import { Link, styled, Typography, useTheme } from "@mui/material";
import AddLogoIcon from "assets/icons/AddLogoIcon";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import { formatPrice as formatPriceBalance } from "helpers/index";
import { generateRgb } from "./CustomPattern";
import { invoiceInitialValues } from "store/reducers/factorReducer";
import { useSelector } from "react-redux";
import { getDefaultCurrency } from "../../../helpers";
// @ts-ignore
import Num2persian from "num2persian";
import { StyledTextareaAutosize as TextareaAutosize } from "../../Input/styled";
const backgroundImage =
  "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23AEAEAEFF' strokeWidth='4' stroke-dasharray='10' stroke-dashoffset='42' stroke-linecap='square'/%3e%3c/svg%3e";

const ItemButton = styled(Link)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "white !important",
  borderRadius: theme?.shape?.borderRadius,
  // width: '100px',
  // height: '100px',
  width: "130px",
  height: "130px",
  justifyContent: "space-evenly",
  alignItems: "center",
  textDecoration: "none"
}));
export const Logo = styled("img")(({ theme }) => ({
  width: "50%",
  height: "auto",
  borderRadius: 5
}));

const AddAccountButton = styled(ItemButton)(({ theme }) => ({
  backgroundImage: `url("${backgroundImage}")`,
  backgroundSize: "100% 100%",
  backgroundColor: "unset"
}));
const InnerSquer = styled("div")(({ theme }) => ({
  height: "100px",
  display: "flex",
  flexDirection: "column",
  width: "100px",
  backgroundColor: "white",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0px 0px 10px 0px #e6e6e6"
}));

export const AddLogoButton = () => {
  return (
    <AddAccountButton>
      <InnerSquer>
        <AddLogoIcon />
        <Typography variant="caption" textAlign="center" color="#B7B7B7">
          لوگوی کسب و کار
        </Typography>
      </InnerSquer>
    </AddAccountButton>
  );
};

const LowerSectionContainer = styled("div")(({ theme }) => ({
  display: "grid",
  // height: '220px',
  paddingBottom: "20px",
  gridTemplateColumns: "55% 40%"
}));

const LowerItem = styled("div")(({ theme }) => ({
  display: "flex",
  paddingRight: "20px",
  flexDirection: "column",
  justifyContent: "space-between",
  marginTop: 12
}));
const LeftItem = styled(LowerItem)(({ theme }) => ({
  justifyContent: "start"
}));

export const TitleItem = styled("div")(({ theme }) => ({
  display: "flex",
  // padding: '25px',
  marginBottom: 8,
  justifyContent: "space-between"
}));

export const LowerSection = ({ data, values }: { data: any; values: typeof invoiceInitialValues }) => {
  // @ts-ignore
  const {
    invoiceHeaderSize,
    invoiceBodySize,
    invoiceHeaderColor,
    invoiceBodyColor,
    description,
    showPaymentPrice,
    showBalancePrice,
    activeSumTax,
    activeSumDiscount,
    activeSumQuantity
  } = values;
  const theme = useTheme();

  const business = useSelector((state: any) => state).businessReducer.business;
  const { currencies } = useSelector((state: any) => state).currencyReducer;

  const defaultCurrency = getDefaultCurrency(business.business.default_currency_id, currencies);

  return (
    <LowerSectionContainer>
      <LeftItem sx={{zIndex:2}}>
        {description && description.length && (
          <>
            <Typography
              sx={{ marginBottom: "4px",zIndex:2 }}
              variant="body2"
              color={generateRgb(invoiceHeaderColor)}
              fontSize={invoiceHeaderSize}
            >
              توضیحات فاکتور:
            </Typography>
            <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} style={{ whiteSpace: 'pre-line' ,zIndex:2 }}>
              {description}
            </Typography>
          </>
        )}
      </LeftItem>
      <LowerItem sx={{zIndex:2}}>
        {activeSumQuantity && <TitleItem>
          <Typography variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
            تعداد
          </Typography>
          <Typography variant="body2">
            {data?.totalQuantity || 0} {data?.unit}
          </Typography>
        </TitleItem>}
        {activeSumDiscount &&
          <TitleItem>
            <Typography color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize} variant="body2">
              جمع تخفیف
            </Typography>
            <PriceComponent price={formatPrice(data?.totalDiscount)} currency={data?.Currency?.en_title} />
          </TitleItem>
        }

        {activeSumTax && <TitleItem>
          <Typography color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize} variant="body2">
            جمع مالیات
          </Typography>
          <PriceComponent price={formatPrice(data?.totalTax)} currency={data?.Currency?.en_title} />
        </TitleItem>}
        <TitleItem>
          <Typography variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
            مبلغ کل
          </Typography>
          <PriceComponent price={formatPrice(data?.total)} currency={data?.Currency?.en_title} />
        </TitleItem>
        {data?.transferPrice ? (
          <TitleItem>
            <Typography variant="body2" color={generateRgb(invoiceHeaderColor)}
              fontSize={invoiceHeaderSize}>
              حمل و نقل
            </Typography>
            <PriceComponent price={formatPrice(data?.transferPrice)} currency={data?.Currency?.en_title} />
          </TitleItem>
        ) : null}
        <div style={{ borderBottom: "1px solid #D9E2EE", marginTop: "5px", marginBottom: "5px" }}></div>
        <TitleItem>
          <Typography
            color={generateRgb(invoiceHeaderColor)}
            fontSize={invoiceHeaderSize}
            fontWeight="bold"
            variant="body2"
          >
            مجموع
          </Typography>
          <PriceComponent price={formatPrice(data?.totalPrice)} currency={data?.Currency?.en_title} />
        </TitleItem>
        {data?.totalPrice ? (
          <Typography color={generateRgb(invoiceBodyColor)} variant="caption">
            <Typography
              color={generateRgb(invoiceHeaderColor)}
              fontSize={invoiceHeaderSize}
              fontWeight="bold"
              variant="body2"
            >
              به حروف
            </Typography>
            {Num2persian(data?.totalPrice)} {data?.Currency?.fa_title}
          </Typography>
        ) : null}
        {showPaymentPrice &&
          (
            <>
              <div style={{ borderBottom: "1px solid #D9E2EE", marginTop: "5px", marginBottom: "5px" }}></div>
              <TitleItem>
                <Typography variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
                  مبلغ پرداخت شده
                </Typography>
                <PriceComponent price={formatPrice(data?.totalTransaction)} currency={data?.Currency?.en_title} />
              </TitleItem>
              <TitleItem>
                <Typography variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
                  مبلغ باقی مانده
                </Typography>
                <PriceComponent price={formatPrice(data?.remaining)} currency={data?.Currency?.en_title} />
              </TitleItem>
            </>
          )}
        {showBalancePrice && (
          <>
            <div style={{ borderBottom: "1px solid #D9E2EE", marginTop: "5px", marginBottom: "5px" }}></div>
            <TitleItem>
              <Typography variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
                تراز شخص
              </Typography>
              <PriceComponent price={formatPriceBalance(data?.Person?.balance).toString()} currency={data?.Currency?.en_title} />
            </TitleItem>
          </>
        )}

        <div style={{ borderBottom: "1px solid #D9E2EE", marginTop: "5px", marginBottom: "5px" }}></div>
        <Typography color={generateRgb(invoiceBodyColor)} variant="caption">
          تمامی قیمت ها بر مبنای ارز {data?.Currency?.fa_title || defaultCurrency.fa_title} میباشد.
        </Typography>
      </LowerItem>
    </LowerSectionContainer>
  );
};
